import React from 'react';
import styled, { css } from 'styled-components';
import { Images } from '../../@resources/img';
import { Colors, toRem } from '../../ui';
import { Shadows } from '../../ui/Standards';
import { Flexer } from '../dashboard/elements/LayoutElements';

const Header = styled.div`
    position: relative;
    display: flex;
    align-items: center;
`;

const Label = styled.div`
    margin: .25rem;
    padding-right: 2.5rem;
    color: ${Colors.text};
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
`;

const Main = styled.div`
    position: relative;
    border: solid .125rem #DDE2EC;
    border-radius: .75rem;
    background: white;
    overflow: hidden;
    cursor: pointer;
`;

const Image = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;

    img { 
        width: 100%;
        height: 100%;
        object-fit: cover;
        pointer-events: none;
    }
`;

const Footer = styled.div`
    display: flex;
    align-items: center;
`;

const Link = styled.div<{ warning?: boolean }>`
    display: flex;
    align-items: center;
    gap: .25rem;
    margin: .25rem;
    font-size: .75rem;
    color: ${p => p.warning ? Colors.mystery : Colors.textLighter};
    text-decoration: underline;
`;

const Date = styled.div`
    margin: .25rem .25rem .25rem auto;
    font-size: .75rem;
    color: ${Colors.textLighter};
`;

const ActionMenu = styled.div`
    position: absolute;
    top: 50%;
    right: -.25rem;
    transform: translateY(-50%);
    z-index: 1;
`;

const Base = styled.div<{ width?: string | number, clickable?: boolean, selected?: boolean }>`
    width: ${p => toRem(p.width || 20)};

    ${Main} {
        width: ${p => toRem(p.width || 20)};
        height: ${p => toRem((parseInt(p.width as any) || 20) * .75)};
    }

    ${p => p.clickable && css`
        user-select: none;  
        
        ${Main} {
            transition: box-shadow .15s ease-out;

            &:hover {
                border: solid .125rem ${Colors.textLightest};
                box-shadow: ${Shadows.md};
                transition: none;
            }
            &:active {
                background: #fcfcfc;
            }

            ${p.selected && css`
                box-shadow: 0 0 0 .125rem ${Colors.primary} !important;
                border: solid .125rem ${Colors.primary} !important;
            `}
        }
    `}
`;

const Thumb = React.memo<{ src: string }>(({ src }) => {
    if (!!src) {
        return <img src={src} />;
    }
    else {
        return <Flexer flex center inset background={Colors.borderLight}>
            <Flexer width="4" height="4">
                <img src={Images.LogoWhite} />
            </Flexer>
        </Flexer>;
    }
});

export const BoardItem = Object.assign(Base, {
    Header,
    Main,
    Footer,
    Label,
    ActionMenu,
    Image,
    Thumb,
    Link,
    Date,
});
